import { PropsWithChildren } from 'react';
import { baseStyles } from '../../../theme/base.styles';

type ISubstitute = {
    key: string;
    value: string;
};

type IProps = {
    tag?: string;
    cssClass?: string;
    substitutes?: ISubstitute[];
};

export default function RenderHtml({
    tag = 'div',
    cssClass = '',
    substitutes = undefined,
    children,
}: PropsWithChildren<IProps>): JSX.Element {
    const baseClasses = baseStyles();
    const TagName: any = tag;
    const cssClasses = `${baseClasses.htmlWrapper}${cssClass ? ` ${cssClass}` : ''}`;

    const getContent = (): string => {
        let content: string = '';
        if (children) {
            content = children.toString();
        }

        if (substitutes) {
            substitutes.forEach((item: ISubstitute) => {
                content = content.replace(item.key, item.value);
            });
        }
        return content;
    };

    return <TagName className={cssClasses} dangerouslySetInnerHTML={{ __html: getContent() }} />;
}
